import { formatImpactRange, formatTL } from '../lib/format.js';

/**
 * §12.2 / §13.2 — "Etki HER ZAMAN aralık olarak gösterilir".
 * Tek bir nokta değeri (impact_tl_month) asla tek başına yazılmaz; orta değer
 * yalnızca başlık (tooltip) içinde referans olarak durur.
 *
 * Referans panelde para etkisi rozet değil, marka renkli düz metindir —
 * satır içinde kalın turuncu okunur.
 *
 * `low`/`high` null ise (R19 gibi bilgi kuralları) "etki hesaplanmaz" yazılır.
 */

export interface ImpactRangeProps {
  low: number | null | undefined;
  high: number | null | undefined;
  /** insights.impact_tl_month — tooltip'te tam değer olarak gösterilir. */
  mid?: number | null;
  /** lg: bulgu kartı başlığı, md: liste satırı, sm: rozet içi. */
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZES: Record<NonNullable<ImpactRangeProps['size']>, string> = {
  sm: 'text-[12px]',
  md: 'text-[13px]',
  lg: 'text-[15px]',
};

export default function ImpactRange({
  low,
  high,
  mid = null,
  size = 'md',
  className = '',
}: ImpactRangeProps) {
  const known = low !== null && low !== undefined && high !== null && high !== undefined;
  const text = formatImpactRange(low, high);

  const title = known
    ? `Aralık: ${formatTL(low)} – ${formatTL(high)}${
        mid !== null && mid !== undefined ? ` (orta: ${formatTL(mid)})` : ''
      } — §12.2 tahmini aylık kayıp`
    : 'Bu kural etki hesaplamaz (bilgi kuralı).';

  return (
    <span
      title={title}
      className={`num inline-flex items-center gap-1.5 whitespace-nowrap font-semibold
        ${known ? 'text-brand' : 'text-[#9ca3af]'}
        ${SIZES[size]} ${className}`}
    >
      {text}
    </span>
  );
}
